export const ROUTE_HOME = '/';
export const ROUTE_LOGIN = '/login';
export const ROUTE_START = '/start';
export const ROUTE_RATING = '/rating';
export const ROUTE_FITTING = '/fitting';
export const ROUTE_SINGAPORE_FINISHED = '/singapore-finished';
export const ROUTE_LAUNCHING_ROCKET = '/launching-rocket';
export const ROUTE_SPORTS_UNIVERSE = '/sports-universe';
export const ROUTE_EMAIL = '/email-optin';
export const ROUTE_ABOUT = '/about';
export const ROUTE_ADDRESS = '/email-optin-address';
export const ROUTE_RESULT_DETAIL = '/result';
export const ROUTE_TESTERS = '/testers';



// WEBPACK FOOTER //
// ./src/RouteList.ts